import { styled } from '@mui/joy';
import ButtonGroup from '@mui/joy/ButtonGroup';

export const BaseButtonGroup = styled(ButtonGroup)`
  border-radius: ${({ theme }) => theme.spacing(1)};
  overflow: hidden;
`;
